/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateUserInput = {
  id?: string | null,
  spotifyPlaylistId?: string | null,
  profile?: UserProfileInput | null,
  stripe__acountId?: string | null,
};

export type UserProfileInput = {
  firstName: string,
  lastName: string,
  profilePicture?: S3ObjectInput | null,
  websiteLink?: string | null,
  bio?: string | null,
};

export type S3ObjectInput = {
  bucket: string,
  key: string,
  region: string,
};

export type ModelUserConditionInput = {
  spotifyPlaylistId?: ModelStringInput | null,
  stripe__acountId?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type User = {
  __typename: "User",
  id: string,
  spotifyPlaylistId?: string | null,
  profile?: UserProfile | null,
  stripe__acountId?: string | null,
  studios?: ModelStudioConnection | null,
  requestedBooking?: ModelBookingConnection | null,
  hostBooking?: ModelBookingConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type UserProfile = {
  __typename: "UserProfile",
  firstName: string,
  lastName: string,
  profilePicture?: S3Object | null,
  websiteLink?: string | null,
  bio?: string | null,
};

export type S3Object = {
  __typename: "S3Object",
  bucket: string,
  key: string,
  region: string,
};

export type ModelStudioConnection = {
  __typename: "ModelStudioConnection",
  items:  Array<Studio | null >,
  nextToken?: string | null,
};

export type Studio = {
  __typename: "Studio",
  id: string,
  status: StudioStatus,
  pendingAdminActions?: Array< StudioPendingAction | null > | null,
  ownerUserId: string,
  owner: User,
  info: StudioInfo,
  bookings?: ModelBookingConnection | null,
  createdAt: string,
  standardAvailability?: StandardAvailability | null,
  availabilityExceptions:  Array<AvailabilityException | null >,
  updatedAt: string,
};

export enum StudioStatus {
  ACTIVE = "ACTIVE",
  PENDING_RESOLVE_ACTIONS = "PENDING_RESOLVE_ACTIONS",
  DELISTED = "DELISTED",
}


export enum StudioPendingAction {
  STRIPE_ACCOUNT_ONBOARDING = "STRIPE_ACCOUNT_ONBOARDING",
}


export type StudioInfo = {
  __typename: "StudioInfo",
  title: string,
  description: string,
  rate: number,
  maxOccupancy: number,
  location: Location,
  minSessionMinutes?: number | null,
  studioPictures:  Array<S3Object | null >,
};

export type Location = {
  __typename: "Location",
  streetAddress: string,
  aptNumber?: string | null,
  city: string,
  state: string,
  zipCode: string,
};

export type ModelBookingConnection = {
  __typename: "ModelBookingConnection",
  items:  Array<Booking | null >,
  nextToken?: string | null,
};

export type Booking = {
  __typename: "Booking",
  id: string,
  totalPriceUSD: number,
  status: BookingStatus,
  studioId: string,
  studio: Studio,
  requesterUserId: string,
  requester: User,
  hostUserId: string,
  host: User,
  startTime: string,
  endTime: string,
  payoutDate?: string | null,
  stripeSessionId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum BookingStatus {
  REQUESTED = "REQUESTED",
  DECLINED = "DECLINED",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PAYMENT_PROCESSING = "PAYMENT_PROCESSING",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  CONFIRMED = "CONFIRMED",
  CANCELLED = "CANCELLED",
}


export type StandardAvailability = {
  __typename: "StandardAvailability",
  timezone: string,
  MONDAY:  Array<TimeRange | null >,
  TUESDAY:  Array<TimeRange | null >,
  WEDNESDAY:  Array<TimeRange | null >,
  THURSDAY:  Array<TimeRange | null >,
  FRIDAY:  Array<TimeRange | null >,
  SATURDAY:  Array<TimeRange | null >,
  SUNDAY:  Array<TimeRange | null >,
};

export type TimeRange = {
  __typename: "TimeRange",
  startTime: Time,
  endTime: Time,
};

export type Time = {
  __typename: "Time",
  hour: number,
  minute: number,
};

export type AvailabilityException = {
  __typename: "AvailabilityException",
  isAvailable: boolean,
  timeRange: DateTimeRange,
};

export type DateTimeRange = {
  __typename: "DateTimeRange",
  startDate: string,
  endDate: string,
};

export type UpdateUserInput = {
  id: string,
  spotifyPlaylistId?: string | null,
  profile?: UserProfileInput | null,
  stripe__acountId?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateStudioInput = {
  id?: string | null,
  status: StudioStatus,
  pendingAdminActions?: Array< StudioPendingAction | null > | null,
  ownerUserId: string,
  info: StudioInfoInput,
  createdAt?: string | null,
  standardAvailability?: StandardAvailabilityInput | null,
  availabilityExceptions: Array< AvailabilityExceptionInput | null >,
};

export type StudioInfoInput = {
  title: string,
  description: string,
  rate: number,
  maxOccupancy: number,
  location: LocationInput,
  minSessionMinutes?: number | null,
  studioPictures: Array< S3ObjectInput | null >,
};

export type LocationInput = {
  streetAddress: string,
  aptNumber?: string | null,
  city: string,
  state: string,
  zipCode: string,
};

export type StandardAvailabilityInput = {
  timezone: string,
  MONDAY: Array< TimeRangeInput | null >,
  TUESDAY: Array< TimeRangeInput | null >,
  WEDNESDAY: Array< TimeRangeInput | null >,
  THURSDAY: Array< TimeRangeInput | null >,
  FRIDAY: Array< TimeRangeInput | null >,
  SATURDAY: Array< TimeRangeInput | null >,
  SUNDAY: Array< TimeRangeInput | null >,
};

export type TimeRangeInput = {
  startTime: TimeInput,
  endTime: TimeInput,
};

export type TimeInput = {
  hour: number,
  minute: number,
};

export type AvailabilityExceptionInput = {
  isAvailable: boolean,
  timeRange: DateTimeRangeInput,
};

export type DateTimeRangeInput = {
  startDate: string,
  endDate: string,
};

export type ModelStudioConditionInput = {
  status?: ModelStudioStatusInput | null,
  pendingAdminActions?: ModelStudioPendingActionListInput | null,
  ownerUserId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelStudioConditionInput | null > | null,
  or?: Array< ModelStudioConditionInput | null > | null,
  not?: ModelStudioConditionInput | null,
};

export type ModelStudioStatusInput = {
  eq?: StudioStatus | null,
  ne?: StudioStatus | null,
};

export type ModelStudioPendingActionListInput = {
  eq?: Array< StudioPendingAction | null > | null,
  ne?: Array< StudioPendingAction | null > | null,
  contains?: StudioPendingAction | null,
  notContains?: StudioPendingAction | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type UpdateStudioInput = {
  id: string,
  status?: StudioStatus | null,
  pendingAdminActions?: Array< StudioPendingAction | null > | null,
  ownerUserId?: string | null,
  info?: StudioInfoInput | null,
  createdAt?: string | null,
  standardAvailability?: StandardAvailabilityInput | null,
  availabilityExceptions?: Array< AvailabilityExceptionInput | null > | null,
};

export type DeleteStudioInput = {
  id: string,
};

export type CreateBookingInput = {
  id?: string | null,
  totalPriceUSD: number,
  status: BookingStatus,
  studioId: string,
  requesterUserId: string,
  hostUserId: string,
  startTime: string,
  endTime: string,
  payoutDate?: string | null,
  stripeSessionId?: string | null,
  createdAt?: string | null,
};

export type ModelBookingConditionInput = {
  totalPriceUSD?: ModelFloatInput | null,
  status?: ModelBookingStatusInput | null,
  studioId?: ModelIDInput | null,
  requesterUserId?: ModelIDInput | null,
  hostUserId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  payoutDate?: ModelStringInput | null,
  stripeSessionId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelBookingConditionInput | null > | null,
  or?: Array< ModelBookingConditionInput | null > | null,
  not?: ModelBookingConditionInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelBookingStatusInput = {
  eq?: BookingStatus | null,
  ne?: BookingStatus | null,
};

export type UpdateBookingInput = {
  id: string,
  totalPriceUSD?: number | null,
  status?: BookingStatus | null,
  studioId?: string | null,
  requesterUserId?: string | null,
  hostUserId?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  payoutDate?: string | null,
  stripeSessionId?: string | null,
  createdAt?: string | null,
};

export type DeleteBookingInput = {
  id: string,
};

export type RequestBookingInput = {
  studioId: string,
  startTime: string,
  endTime: string,
};

export type RequestBookingOutput = {
  __typename: "RequestBookingOutput",
  bookingId: string,
  studioId: string,
  requesterUserId: string,
  hostUserId: string,
  startTime: string,
  endTime: string,
};

export type RespondBookingRequestInput = {
  bookingId: string,
  accept: boolean,
};

export type RespondBookingRequestOutput = {
  __typename: "RespondBookingRequestOutput",
  status: BookingStatus,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  spotifyPlaylistId?: ModelStringInput | null,
  stripe__acountId?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelStudioFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStudioStatusInput | null,
  pendingAdminActions?: ModelStudioPendingActionListInput | null,
  ownerUserId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelStudioFilterInput | null > | null,
  or?: Array< ModelStudioFilterInput | null > | null,
  not?: ModelStudioFilterInput | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelBookingFilterInput = {
  id?: ModelIDInput | null,
  totalPriceUSD?: ModelFloatInput | null,
  status?: ModelBookingStatusInput | null,
  studioId?: ModelIDInput | null,
  requesterUserId?: ModelIDInput | null,
  hostUserId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  payoutDate?: ModelStringInput | null,
  stripeSessionId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelBookingFilterInput | null > | null,
  or?: Array< ModelBookingFilterInput | null > | null,
  not?: ModelBookingFilterInput | null,
};

export type EchoMessage = {
  __typename: "EchoMessage",
  message?: string | null,
};

export type UserStripeAccount = {
  __typename: "UserStripeAccount",
  id?: string | null,
  chargesEnabled?: boolean | null,
  onboarded: boolean,
};

export type Link = {
  __typename: "Link",
  url: string,
};

export type GetStripeOnboardingLinkInput = {
  refreshUrl: string,
  returnUrl: string,
};

export type GetStripeOnboardingLinkOutput = {
  __typename: "GetStripeOnboardingLinkOutput",
  url: string,
};

export type GetOpenAvailabilitiesInput = {
  studioId: string,
  date: string,
};

export type GetOpenAvailabilitiesOutput = {
  __typename: "GetOpenAvailabilitiesOutput",
  timeslots:  Array<DateTimeRange | null >,
};

export type GetBookingCheckoutSessionInput = {
  bookingId: string,
  successUrl: string,
  cancelUrl: string,
};

export type GetBookingCheckoutSessionOutput = {
  __typename: "GetBookingCheckoutSessionOutput",
  checkoutUrl: string,
};

export type ModelSubscriptionUserFilterInput = {
  spotifyPlaylistId?: ModelSubscriptionStringInput | null,
  stripe__acountId?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStudioFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  pendingAdminActions?: ModelSubscriptionStringInput | null,
  ownerUserId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionStudioFilterInput | null > | null,
  or?: Array< ModelSubscriptionStudioFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBookingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  totalPriceUSD?: ModelSubscriptionFloatInput | null,
  status?: ModelSubscriptionStringInput | null,
  studioId?: ModelSubscriptionIDInput | null,
  requesterUserId?: ModelSubscriptionIDInput | null,
  hostUserId?: ModelSubscriptionIDInput | null,
  startTime?: ModelSubscriptionStringInput | null,
  endTime?: ModelSubscriptionStringInput | null,
  payoutDate?: ModelSubscriptionStringInput | null,
  stripeSessionId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBookingFilterInput | null > | null,
  or?: Array< ModelSubscriptionBookingFilterInput | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    spotifyPlaylistId?: string | null,
    profile?:  {
      __typename: "UserProfile",
      firstName: string,
      lastName: string,
      profilePicture?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null,
      websiteLink?: string | null,
      bio?: string | null,
    } | null,
    stripe__acountId?: string | null,
    studios?:  {
      __typename: "ModelStudioConnection",
      items:  Array< {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    requestedBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    hostBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    spotifyPlaylistId?: string | null,
    profile?:  {
      __typename: "UserProfile",
      firstName: string,
      lastName: string,
      profilePicture?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null,
      websiteLink?: string | null,
      bio?: string | null,
    } | null,
    stripe__acountId?: string | null,
    studios?:  {
      __typename: "ModelStudioConnection",
      items:  Array< {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    requestedBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    hostBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    spotifyPlaylistId?: string | null,
    profile?:  {
      __typename: "UserProfile",
      firstName: string,
      lastName: string,
      profilePicture?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null,
      websiteLink?: string | null,
      bio?: string | null,
    } | null,
    stripe__acountId?: string | null,
    studios?:  {
      __typename: "ModelStudioConnection",
      items:  Array< {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    requestedBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    hostBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateStudioMutationVariables = {
  input: CreateStudioInput,
  condition?: ModelStudioConditionInput | null,
};

export type CreateStudioMutation = {
  createStudio?:  {
    __typename: "Studio",
    id: string,
    status: StudioStatus,
    pendingAdminActions?: Array< StudioPendingAction | null > | null,
    ownerUserId: string,
    owner:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    info:  {
      __typename: "StudioInfo",
      title: string,
      description: string,
      rate: number,
      maxOccupancy: number,
      location:  {
        __typename: "Location",
        streetAddress: string,
        aptNumber?: string | null,
        city: string,
        state: string,
        zipCode: string,
      },
      minSessionMinutes?: number | null,
      studioPictures:  Array< {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null >,
    },
    bookings?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    standardAvailability?:  {
      __typename: "StandardAvailability",
      timezone: string,
      MONDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      TUESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      WEDNESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      THURSDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      FRIDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SATURDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SUNDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
    } | null,
    availabilityExceptions:  Array< {
      __typename: "AvailabilityException",
      isAvailable: boolean,
      timeRange:  {
        __typename: "DateTimeRange",
        startDate: string,
        endDate: string,
      },
    } | null >,
    updatedAt: string,
  } | null,
};

export type UpdateStudioMutationVariables = {
  input: UpdateStudioInput,
  condition?: ModelStudioConditionInput | null,
};

export type UpdateStudioMutation = {
  updateStudio?:  {
    __typename: "Studio",
    id: string,
    status: StudioStatus,
    pendingAdminActions?: Array< StudioPendingAction | null > | null,
    ownerUserId: string,
    owner:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    info:  {
      __typename: "StudioInfo",
      title: string,
      description: string,
      rate: number,
      maxOccupancy: number,
      location:  {
        __typename: "Location",
        streetAddress: string,
        aptNumber?: string | null,
        city: string,
        state: string,
        zipCode: string,
      },
      minSessionMinutes?: number | null,
      studioPictures:  Array< {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null >,
    },
    bookings?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    standardAvailability?:  {
      __typename: "StandardAvailability",
      timezone: string,
      MONDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      TUESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      WEDNESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      THURSDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      FRIDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SATURDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SUNDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
    } | null,
    availabilityExceptions:  Array< {
      __typename: "AvailabilityException",
      isAvailable: boolean,
      timeRange:  {
        __typename: "DateTimeRange",
        startDate: string,
        endDate: string,
      },
    } | null >,
    updatedAt: string,
  } | null,
};

export type DeleteStudioMutationVariables = {
  input: DeleteStudioInput,
  condition?: ModelStudioConditionInput | null,
};

export type DeleteStudioMutation = {
  deleteStudio?:  {
    __typename: "Studio",
    id: string,
    status: StudioStatus,
    pendingAdminActions?: Array< StudioPendingAction | null > | null,
    ownerUserId: string,
    owner:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    info:  {
      __typename: "StudioInfo",
      title: string,
      description: string,
      rate: number,
      maxOccupancy: number,
      location:  {
        __typename: "Location",
        streetAddress: string,
        aptNumber?: string | null,
        city: string,
        state: string,
        zipCode: string,
      },
      minSessionMinutes?: number | null,
      studioPictures:  Array< {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null >,
    },
    bookings?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    standardAvailability?:  {
      __typename: "StandardAvailability",
      timezone: string,
      MONDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      TUESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      WEDNESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      THURSDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      FRIDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SATURDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SUNDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
    } | null,
    availabilityExceptions:  Array< {
      __typename: "AvailabilityException",
      isAvailable: boolean,
      timeRange:  {
        __typename: "DateTimeRange",
        startDate: string,
        endDate: string,
      },
    } | null >,
    updatedAt: string,
  } | null,
};

export type CreateBookingMutationVariables = {
  input: CreateBookingInput,
  condition?: ModelBookingConditionInput | null,
};

export type CreateBookingMutation = {
  createBooking?:  {
    __typename: "Booking",
    id: string,
    totalPriceUSD: number,
    status: BookingStatus,
    studioId: string,
    studio:  {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    },
    requesterUserId: string,
    requester:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    hostUserId: string,
    host:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: string,
    endTime: string,
    payoutDate?: string | null,
    stripeSessionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBookingMutationVariables = {
  input: UpdateBookingInput,
  condition?: ModelBookingConditionInput | null,
};

export type UpdateBookingMutation = {
  updateBooking?:  {
    __typename: "Booking",
    id: string,
    totalPriceUSD: number,
    status: BookingStatus,
    studioId: string,
    studio:  {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    },
    requesterUserId: string,
    requester:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    hostUserId: string,
    host:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: string,
    endTime: string,
    payoutDate?: string | null,
    stripeSessionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBookingMutationVariables = {
  input: DeleteBookingInput,
  condition?: ModelBookingConditionInput | null,
};

export type DeleteBookingMutation = {
  deleteBooking?:  {
    __typename: "Booking",
    id: string,
    totalPriceUSD: number,
    status: BookingStatus,
    studioId: string,
    studio:  {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    },
    requesterUserId: string,
    requester:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    hostUserId: string,
    host:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: string,
    endTime: string,
    payoutDate?: string | null,
    stripeSessionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type RequestBookingMutationVariables = {
  input: RequestBookingInput,
};

export type RequestBookingMutation = {
  requestBooking?:  {
    __typename: "RequestBookingOutput",
    bookingId: string,
    studioId: string,
    requesterUserId: string,
    hostUserId: string,
    startTime: string,
    endTime: string,
  } | null,
};

export type RespondToBookingRequestMutationVariables = {
  input: RespondBookingRequestInput,
};

export type RespondToBookingRequestMutation = {
  respondToBookingRequest?:  {
    __typename: "RespondBookingRequestOutput",
    status: BookingStatus,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    spotifyPlaylistId?: string | null,
    profile?:  {
      __typename: "UserProfile",
      firstName: string,
      lastName: string,
      profilePicture?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null,
      websiteLink?: string | null,
      bio?: string | null,
    } | null,
    stripe__acountId?: string | null,
    studios?:  {
      __typename: "ModelStudioConnection",
      items:  Array< {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    requestedBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    hostBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  id?: string | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStudioQueryVariables = {
  id: string,
};

export type GetStudioQuery = {
  getStudio?:  {
    __typename: "Studio",
    id: string,
    status: StudioStatus,
    pendingAdminActions?: Array< StudioPendingAction | null > | null,
    ownerUserId: string,
    owner:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    info:  {
      __typename: "StudioInfo",
      title: string,
      description: string,
      rate: number,
      maxOccupancy: number,
      location:  {
        __typename: "Location",
        streetAddress: string,
        aptNumber?: string | null,
        city: string,
        state: string,
        zipCode: string,
      },
      minSessionMinutes?: number | null,
      studioPictures:  Array< {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null >,
    },
    bookings?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    standardAvailability?:  {
      __typename: "StandardAvailability",
      timezone: string,
      MONDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      TUESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      WEDNESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      THURSDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      FRIDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SATURDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SUNDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
    } | null,
    availabilityExceptions:  Array< {
      __typename: "AvailabilityException",
      isAvailable: boolean,
      timeRange:  {
        __typename: "DateTimeRange",
        startDate: string,
        endDate: string,
      },
    } | null >,
    updatedAt: string,
  } | null,
};

export type ListStudiosQueryVariables = {
  id?: string | null,
  filter?: ModelStudioFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListStudiosQuery = {
  listStudios?:  {
    __typename: "ModelStudioConnection",
    items:  Array< {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StudiosByOwnerUserIdAndCreatedAtQueryVariables = {
  ownerUserId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStudioFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StudiosByOwnerUserIdAndCreatedAtQuery = {
  studiosByOwnerUserIdAndCreatedAt?:  {
    __typename: "ModelStudioConnection",
    items:  Array< {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBookingQueryVariables = {
  id: string,
};

export type GetBookingQuery = {
  getBooking?:  {
    __typename: "Booking",
    id: string,
    totalPriceUSD: number,
    status: BookingStatus,
    studioId: string,
    studio:  {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    },
    requesterUserId: string,
    requester:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    hostUserId: string,
    host:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: string,
    endTime: string,
    payoutDate?: string | null,
    stripeSessionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBookingsQueryVariables = {
  id?: string | null,
  filter?: ModelBookingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBookingsQuery = {
  listBookings?:  {
    __typename: "ModelBookingConnection",
    items:  Array< {
      __typename: "Booking",
      id: string,
      totalPriceUSD: number,
      status: BookingStatus,
      studioId: string,
      studio:  {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      },
      requesterUserId: string,
      requester:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      hostUserId: string,
      host:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      startTime: string,
      endTime: string,
      payoutDate?: string | null,
      stripeSessionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BookingsByStudioIdAndStartTimeQueryVariables = {
  studioId: string,
  startTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBookingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BookingsByStudioIdAndStartTimeQuery = {
  bookingsByStudioIdAndStartTime?:  {
    __typename: "ModelBookingConnection",
    items:  Array< {
      __typename: "Booking",
      id: string,
      totalPriceUSD: number,
      status: BookingStatus,
      studioId: string,
      studio:  {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      },
      requesterUserId: string,
      requester:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      hostUserId: string,
      host:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      startTime: string,
      endTime: string,
      payoutDate?: string | null,
      stripeSessionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BookingsByRequesterUserIdAndStartTimeQueryVariables = {
  requesterUserId: string,
  startTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBookingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BookingsByRequesterUserIdAndStartTimeQuery = {
  bookingsByRequesterUserIdAndStartTime?:  {
    __typename: "ModelBookingConnection",
    items:  Array< {
      __typename: "Booking",
      id: string,
      totalPriceUSD: number,
      status: BookingStatus,
      studioId: string,
      studio:  {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      },
      requesterUserId: string,
      requester:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      hostUserId: string,
      host:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      startTime: string,
      endTime: string,
      payoutDate?: string | null,
      stripeSessionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BookingsByHostUserIdAndStartTimeQueryVariables = {
  hostUserId: string,
  startTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBookingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BookingsByHostUserIdAndStartTimeQuery = {
  bookingsByHostUserIdAndStartTime?:  {
    __typename: "ModelBookingConnection",
    items:  Array< {
      __typename: "Booking",
      id: string,
      totalPriceUSD: number,
      status: BookingStatus,
      studioId: string,
      studio:  {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      },
      requesterUserId: string,
      requester:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      hostUserId: string,
      host:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      startTime: string,
      endTime: string,
      payoutDate?: string | null,
      stripeSessionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BookingsByPayoutDateAndStatusQueryVariables = {
  payoutDate: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBookingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BookingsByPayoutDateAndStatusQuery = {
  bookingsByPayoutDateAndStatus?:  {
    __typename: "ModelBookingConnection",
    items:  Array< {
      __typename: "Booking",
      id: string,
      totalPriceUSD: number,
      status: BookingStatus,
      studioId: string,
      studio:  {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      },
      requesterUserId: string,
      requester:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      hostUserId: string,
      host:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      startTime: string,
      endTime: string,
      payoutDate?: string | null,
      stripeSessionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BookingsByCreatedAtAndStatusQueryVariables = {
  createdAt: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBookingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BookingsByCreatedAtAndStatusQuery = {
  bookingsByCreatedAtAndStatus?:  {
    __typename: "ModelBookingConnection",
    items:  Array< {
      __typename: "Booking",
      id: string,
      totalPriceUSD: number,
      status: BookingStatus,
      studioId: string,
      studio:  {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      },
      requesterUserId: string,
      requester:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      hostUserId: string,
      host:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      startTime: string,
      endTime: string,
      payoutDate?: string | null,
      stripeSessionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EchoQueryVariables = {
  message?: string | null,
};

export type EchoQuery = {
  echo?:  {
    __typename: "EchoMessage",
    message?: string | null,
  } | null,
};

export type GetUserStripeAccountQuery = {
  getUserStripeAccount?:  {
    __typename: "UserStripeAccount",
    id?: string | null,
    chargesEnabled?: boolean | null,
    onboarded: boolean,
  } | null,
};

export type GetStripeLoginLinkQuery = {
  getStripeLoginLink?:  {
    __typename: "Link",
    url: string,
  } | null,
};

export type GetUserStripeOnboardingLinkQueryVariables = {
  input?: GetStripeOnboardingLinkInput | null,
};

export type GetUserStripeOnboardingLinkQuery = {
  getUserStripeOnboardingLink?:  {
    __typename: "GetStripeOnboardingLinkOutput",
    url: string,
  } | null,
};

export type GetOpenAvailabilitiesQueryVariables = {
  input?: GetOpenAvailabilitiesInput | null,
};

export type GetOpenAvailabilitiesQuery = {
  getOpenAvailabilities?:  {
    __typename: "GetOpenAvailabilitiesOutput",
    timeslots:  Array< {
      __typename: "DateTimeRange",
      startDate: string,
      endDate: string,
    } | null >,
  } | null,
};

export type GetBookingCheckoutSessionQueryVariables = {
  input?: GetBookingCheckoutSessionInput | null,
};

export type GetBookingCheckoutSessionQuery = {
  getBookingCheckoutSession?:  {
    __typename: "GetBookingCheckoutSessionOutput",
    checkoutUrl: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    spotifyPlaylistId?: string | null,
    profile?:  {
      __typename: "UserProfile",
      firstName: string,
      lastName: string,
      profilePicture?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null,
      websiteLink?: string | null,
      bio?: string | null,
    } | null,
    stripe__acountId?: string | null,
    studios?:  {
      __typename: "ModelStudioConnection",
      items:  Array< {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    requestedBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    hostBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    spotifyPlaylistId?: string | null,
    profile?:  {
      __typename: "UserProfile",
      firstName: string,
      lastName: string,
      profilePicture?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null,
      websiteLink?: string | null,
      bio?: string | null,
    } | null,
    stripe__acountId?: string | null,
    studios?:  {
      __typename: "ModelStudioConnection",
      items:  Array< {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    requestedBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    hostBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    spotifyPlaylistId?: string | null,
    profile?:  {
      __typename: "UserProfile",
      firstName: string,
      lastName: string,
      profilePicture?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null,
      websiteLink?: string | null,
      bio?: string | null,
    } | null,
    stripe__acountId?: string | null,
    studios?:  {
      __typename: "ModelStudioConnection",
      items:  Array< {
        __typename: "Studio",
        id: string,
        status: StudioStatus,
        pendingAdminActions?: Array< StudioPendingAction | null > | null,
        ownerUserId: string,
        owner:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        info:  {
          __typename: "StudioInfo",
          title: string,
          description: string,
          rate: number,
          maxOccupancy: number,
          minSessionMinutes?: number | null,
        },
        bookings?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        standardAvailability?:  {
          __typename: "StandardAvailability",
          timezone: string,
        } | null,
        availabilityExceptions:  Array< {
          __typename: "AvailabilityException",
          isAvailable: boolean,
        } | null >,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    requestedBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    hostBooking?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateStudioSubscriptionVariables = {
  filter?: ModelSubscriptionStudioFilterInput | null,
  owner?: string | null,
};

export type OnCreateStudioSubscription = {
  onCreateStudio?:  {
    __typename: "Studio",
    id: string,
    status: StudioStatus,
    pendingAdminActions?: Array< StudioPendingAction | null > | null,
    ownerUserId: string,
    owner:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    info:  {
      __typename: "StudioInfo",
      title: string,
      description: string,
      rate: number,
      maxOccupancy: number,
      location:  {
        __typename: "Location",
        streetAddress: string,
        aptNumber?: string | null,
        city: string,
        state: string,
        zipCode: string,
      },
      minSessionMinutes?: number | null,
      studioPictures:  Array< {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null >,
    },
    bookings?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    standardAvailability?:  {
      __typename: "StandardAvailability",
      timezone: string,
      MONDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      TUESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      WEDNESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      THURSDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      FRIDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SATURDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SUNDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
    } | null,
    availabilityExceptions:  Array< {
      __typename: "AvailabilityException",
      isAvailable: boolean,
      timeRange:  {
        __typename: "DateTimeRange",
        startDate: string,
        endDate: string,
      },
    } | null >,
    updatedAt: string,
  } | null,
};

export type OnUpdateStudioSubscriptionVariables = {
  filter?: ModelSubscriptionStudioFilterInput | null,
  owner?: string | null,
};

export type OnUpdateStudioSubscription = {
  onUpdateStudio?:  {
    __typename: "Studio",
    id: string,
    status: StudioStatus,
    pendingAdminActions?: Array< StudioPendingAction | null > | null,
    ownerUserId: string,
    owner:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    info:  {
      __typename: "StudioInfo",
      title: string,
      description: string,
      rate: number,
      maxOccupancy: number,
      location:  {
        __typename: "Location",
        streetAddress: string,
        aptNumber?: string | null,
        city: string,
        state: string,
        zipCode: string,
      },
      minSessionMinutes?: number | null,
      studioPictures:  Array< {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null >,
    },
    bookings?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    standardAvailability?:  {
      __typename: "StandardAvailability",
      timezone: string,
      MONDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      TUESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      WEDNESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      THURSDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      FRIDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SATURDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SUNDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
    } | null,
    availabilityExceptions:  Array< {
      __typename: "AvailabilityException",
      isAvailable: boolean,
      timeRange:  {
        __typename: "DateTimeRange",
        startDate: string,
        endDate: string,
      },
    } | null >,
    updatedAt: string,
  } | null,
};

export type OnDeleteStudioSubscriptionVariables = {
  filter?: ModelSubscriptionStudioFilterInput | null,
  owner?: string | null,
};

export type OnDeleteStudioSubscription = {
  onDeleteStudio?:  {
    __typename: "Studio",
    id: string,
    status: StudioStatus,
    pendingAdminActions?: Array< StudioPendingAction | null > | null,
    ownerUserId: string,
    owner:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    info:  {
      __typename: "StudioInfo",
      title: string,
      description: string,
      rate: number,
      maxOccupancy: number,
      location:  {
        __typename: "Location",
        streetAddress: string,
        aptNumber?: string | null,
        city: string,
        state: string,
        zipCode: string,
      },
      minSessionMinutes?: number | null,
      studioPictures:  Array< {
        __typename: "S3Object",
        bucket: string,
        key: string,
        region: string,
      } | null >,
    },
    bookings?:  {
      __typename: "ModelBookingConnection",
      items:  Array< {
        __typename: "Booking",
        id: string,
        totalPriceUSD: number,
        status: BookingStatus,
        studioId: string,
        studio:  {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        },
        requesterUserId: string,
        requester:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        hostUserId: string,
        host:  {
          __typename: "User",
          id: string,
          spotifyPlaylistId?: string | null,
          stripe__acountId?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        startTime: string,
        endTime: string,
        payoutDate?: string | null,
        stripeSessionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    standardAvailability?:  {
      __typename: "StandardAvailability",
      timezone: string,
      MONDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      TUESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      WEDNESDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      THURSDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      FRIDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SATURDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
      SUNDAY:  Array< {
        __typename: "TimeRange",
        startTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
        endTime:  {
          __typename: "Time",
          hour: number,
          minute: number,
        },
      } | null >,
    } | null,
    availabilityExceptions:  Array< {
      __typename: "AvailabilityException",
      isAvailable: boolean,
      timeRange:  {
        __typename: "DateTimeRange",
        startDate: string,
        endDate: string,
      },
    } | null >,
    updatedAt: string,
  } | null,
};

export type OnCreateBookingSubscriptionVariables = {
  filter?: ModelSubscriptionBookingFilterInput | null,
};

export type OnCreateBookingSubscription = {
  onCreateBooking?:  {
    __typename: "Booking",
    id: string,
    totalPriceUSD: number,
    status: BookingStatus,
    studioId: string,
    studio:  {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    },
    requesterUserId: string,
    requester:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    hostUserId: string,
    host:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: string,
    endTime: string,
    payoutDate?: string | null,
    stripeSessionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBookingSubscriptionVariables = {
  filter?: ModelSubscriptionBookingFilterInput | null,
};

export type OnUpdateBookingSubscription = {
  onUpdateBooking?:  {
    __typename: "Booking",
    id: string,
    totalPriceUSD: number,
    status: BookingStatus,
    studioId: string,
    studio:  {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    },
    requesterUserId: string,
    requester:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    hostUserId: string,
    host:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: string,
    endTime: string,
    payoutDate?: string | null,
    stripeSessionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBookingSubscriptionVariables = {
  filter?: ModelSubscriptionBookingFilterInput | null,
};

export type OnDeleteBookingSubscription = {
  onDeleteBooking?:  {
    __typename: "Booking",
    id: string,
    totalPriceUSD: number,
    status: BookingStatus,
    studioId: string,
    studio:  {
      __typename: "Studio",
      id: string,
      status: StudioStatus,
      pendingAdminActions?: Array< StudioPendingAction | null > | null,
      ownerUserId: string,
      owner:  {
        __typename: "User",
        id: string,
        spotifyPlaylistId?: string | null,
        profile?:  {
          __typename: "UserProfile",
          firstName: string,
          lastName: string,
          websiteLink?: string | null,
          bio?: string | null,
        } | null,
        stripe__acountId?: string | null,
        studios?:  {
          __typename: "ModelStudioConnection",
          nextToken?: string | null,
        } | null,
        requestedBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        hostBooking?:  {
          __typename: "ModelBookingConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      info:  {
        __typename: "StudioInfo",
        title: string,
        description: string,
        rate: number,
        maxOccupancy: number,
        location:  {
          __typename: "Location",
          streetAddress: string,
          aptNumber?: string | null,
          city: string,
          state: string,
          zipCode: string,
        },
        minSessionMinutes?: number | null,
        studioPictures:  Array< {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null >,
      },
      bookings?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      standardAvailability?:  {
        __typename: "StandardAvailability",
        timezone: string,
      } | null,
      availabilityExceptions:  Array< {
        __typename: "AvailabilityException",
        isAvailable: boolean,
        timeRange:  {
          __typename: "DateTimeRange",
          startDate: string,
          endDate: string,
        },
      } | null >,
      updatedAt: string,
    },
    requesterUserId: string,
    requester:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    hostUserId: string,
    host:  {
      __typename: "User",
      id: string,
      spotifyPlaylistId?: string | null,
      profile?:  {
        __typename: "UserProfile",
        firstName: string,
        lastName: string,
        profilePicture?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          region: string,
        } | null,
        websiteLink?: string | null,
        bio?: string | null,
      } | null,
      stripe__acountId?: string | null,
      studios?:  {
        __typename: "ModelStudioConnection",
        items:  Array< {
          __typename: "Studio",
          id: string,
          status: StudioStatus,
          pendingAdminActions?: Array< StudioPendingAction | null > | null,
          ownerUserId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      requestedBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      hostBooking?:  {
        __typename: "ModelBookingConnection",
        items:  Array< {
          __typename: "Booking",
          id: string,
          totalPriceUSD: number,
          status: BookingStatus,
          studioId: string,
          requesterUserId: string,
          hostUserId: string,
          startTime: string,
          endTime: string,
          payoutDate?: string | null,
          stripeSessionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: string,
    endTime: string,
    payoutDate?: string | null,
    stripeSessionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};
